import { FULL_WIDTH_CLASS_NAME } from './EditGridElementModal.constants';

export function isFullWidthClassName(className = '') {
  return className.split(' ').includes(FULL_WIDTH_CLASS_NAME);
}

export function removeFullWidthClassName(className = '') {
  return className
    .split(' ')
    .filter((name) => name !== FULL_WIDTH_CLASS_NAME)
    .join(' ');
}

export function ensureFullWidthClassName(className = '') {
  if (isFullWidthClassName(className)) {
    return className;
  }
  return [className, FULL_WIDTH_CLASS_NAME].join(' ');
}
